import { render } from "./ProjectForecast.vue?vue&type=template&id=807484f4"
import script from "./ProjectForecast.vue?vue&type=script&lang=js"
export * from "./ProjectForecast.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__